import React from 'react';
import style from './style.scss'; //NOSONAR
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';


const ProductItem = (props) => {

    const { product } = props;
    if (!product) return;
    const item = (product.items && product.items.length) ? product.items[0] : null;

    return (
        <div className="wrap-product-not-available">
            {item && <span className="wrap-image-product-not-available">
                <ImageLoad src={item.images[0].imageUrl} alt={product.metaTagDescription} />
            </span>}

            <h3 className="wrap-title-product-not-available">{product.productName}</h3>
        </div>
    )
}


ProductItem.propTypes = {
    product: PropTypes.object

}


export default ProductItem;
